import { EntityState, createSlice } from '@reduxjs/toolkit';
import { TournamentBracket } from 'modules/championship/domain/interfaces/tournament-bracket';
import bracketsAdapter from './brackets.adapter';
import { fetchStages, refreshStage, setStageBracketsTeams, upsertStage } from './stages.actions';

/** Сетки этапа целиком заменяются пришедшими: удалённые бэкендом узлы не должны остаться в сторе. */
const replaceStageBrackets = (state: EntityState<TournamentBracket>, stageId: number, brackets: TournamentBracket[]) => {
  const existingBrackets = bracketsAdapter.getSelectors().selectAll(state);
  const stageBracketKeys = existingBrackets.filter((b) => b.stageId === stageId).map((b) => b.id);

  const removedStageBracketsState = bracketsAdapter.removeMany(state, stageBracketKeys);
  return bracketsAdapter.upsertMany(removedStageBracketsState, brackets);
};

const bracketsSlice = createSlice({
  name: 'brackets',
  initialState: bracketsAdapter.getInitialState(),
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchStages.fulfilled, (state, action) => {
      const brackets = action.payload.reduce<TournamentBracket[]>((acc, stage) => [...acc, ...stage.brackets], []);

      bracketsAdapter.setAll(state, brackets);
    });

    builder.addMatcher(setStageBracketsTeams.fulfilled.match, (state, action) => {
      const brackets = action.payload;
      return bracketsAdapter.upsertMany(state, brackets);
    });

    builder.addMatcher(upsertStage.fulfilled.match, (state, action) => {
      const { id: stageId, brackets } = action.payload.stage;
      return replaceStageBrackets(state, stageId, brackets);
    });

    builder.addMatcher(refreshStage.fulfilled.match, (state, action) => {
      const { id: stageId, brackets } = action.payload;
      return replaceStageBrackets(state, stageId, brackets);
    });
  },
});

export default bracketsSlice;
